import { Box, Card, Group, Stack, Text } from '@mantine/core';
import { Link } from 'react-router-dom';

const SingleDataCard = ({ heading, moreLink, children }) => {
  return (
    <Card shadow="xs" style={{"& a": { color: '#2725f2' }}}>
      <Stack>
        <Group justify="space-between">
          <Text component="h4" style={{ margin: 0, fontSize: 18 }}>{heading}</Text>
          <Link to={moreLink}>Alle &rsaquo;</Link>
        </Group>
        <Box>
          {children}
        </Box>
      </Stack>
    </Card>
  )
}

export default SingleDataCard;